module.exports = __webpack_public_path__ + "static/media/Infor.0b31cc87.svg";